// extracted by mini-css-extract-plugin
export default {"KpiNotifications":"KpiAlertsManagement_KpiNotifications__BIxTc","whiteWrapper":"KpiAlertsManagement_whiteWrapper__hXikp","vendor":"KpiAlertsManagement_vendor__b4MCU"};